module.exports = __webpack_public_path__ + "images/emoji/panda_face.c2a71a485cff430687d5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/panda_face.png
// module id = XuLV
// module chunks = 24